// Suivi de provenance (WhatsApp, Instagram, Facebook, Google, Web).
// Priorité : paramètre ?src= (ou ?utm_source=) > source déjà mémorisée (first-touch)
// > détection via le référent du navigateur > "web" par défaut.
import { api } from "@/lib/api";

const KEY = "gestimmony_src";

function fromQuery() {
  try {
    const p = new URLSearchParams(window.location.search);
    return (p.get("src") || p.get("utm_source") || "").toLowerCase();
  } catch {
    return "";
  }
}

export function resolveSource() {
  const raw = fromQuery();
  if (raw) return raw;
  try {
    const stored = localStorage.getItem(KEY);
    if (stored) return stored;
    const r = (document.referrer || "").toLowerCase();
    if (r.includes("instagram")) return "instagram";
    if (r.includes("facebook") || r.includes("fb.")) return "facebook";
    if (r.includes("whatsapp") || r.includes("wa.me")) return "whatsapp";
    if (r.includes("google")) return "google";
  } catch {
    /* noop */
  }
  return "web";
}

// Mémorise la toute première provenance (first-touch), pour l'inscription ultérieure.
export function storeSource() {
  try {
    const raw = fromQuery();
    if (raw && !localStorage.getItem(KEY)) localStorage.setItem(KEY, raw);
  } catch {
    /* noop */
  }
}

export function getStoredSource() {
  try {
    return localStorage.getItem(KEY) || resolveSource();
  } catch {
    return "web";
  }
}

// Enregistre une visite (une seule fois par session).
export async function trackVisit() {
  try {
    storeSource();
    if (sessionStorage.getItem("gestimmony_visit_tracked")) return;
    sessionStorage.setItem("gestimmony_visit_tracked", "1");
    await api.post("/track/visit", {
      source: fromQuery(),
      referrer: document.referrer || "",
      path: window.location.pathname,
    });
  } catch {
    /* le suivi ne doit jamais bloquer la page */
  }
}
